/* eslint-disable no-alert */
import React, { createContext, useEffect, useReducer, useState } from 'react';

const SET_WIFI_LIST = 'wifi/SET_WIFI_LIST';
const SET_USB_STATE = 'wifi/SET_USB_STATE';
const initialState = {
  wifiList: [],
  usbState: false,
};
/* const testState = {
  wifiList: [
    { mac: '18:81:0e:de:74:1e', ssid: 'circulus-ops', security: 'WEP' },
  ],
  usbState: true,
}; */
const reducer = (state, action) => {
  switch (action.type) {
    case SET_WIFI_LIST:
      return {
        ...state,
        wifiList: action.payload.wifiList,
      };
    case SET_USB_STATE:
      return {
        ...state,
        usbState: action.payload.usbState,
      };
    default:
      return initialState;
  }
};

export const WifiContext = createContext();
const WifiContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [pending, setPending] = useState(false);
  const checkMessage = (e) => {
    const { wifiList, usbConnect, fileSave } = e.data;
    if (wifiList)
      // wifiList
      dispatch({ type: SET_WIFI_LIST, payload: { wifiList } });
    else if (typeof usbConnect === 'boolean')
      // usb연결 여부
      dispatch({ type: SET_USB_STATE, payload: { usbState: usbConnect } });
    else if (typeof fileSave === 'boolean')
      // 파일 저장 여부
      alert(
        `파일이 ${
          fileSave
            ? '성공적으로 저장되었습니다.'
            : '와이파이 저장에 실패하였습니다. USB를 확인해주세요.'
        }`,
      );
  };
  const sendWifiInfo = (wifi) => {
    window.parent.postMessage(wifi, '*');
  };
  const getWifiList = () => {
    window.parent.postMessage('wifi', '*');
  };
  useEffect(() => {
    setPending(true);
    window.addEventListener('message', checkMessage);
    window.parent.postMessage('wifi', '*');

    return () => {
      setPending(false);
      window.removeEventListener('message', checkMessage);
    };
  }, []);
  const actions = {
    sendWifiInfo,
    getWifiList,
  };
  return (
    <WifiContext.Provider value={{ state, actions }}>
      {pending && children}
    </WifiContext.Provider>
  );
};

export default WifiContextProvider;
